export const SOCKET_CONNECT_REALTIME_EVENTS = 'SOCKET_CONNECT_REALTIME_EVENTS';
export const SOCKET_CONNECTED_REALTIME_EVENTS = 'SOCKET_CONNECTED_REALTIME_EVENTS';
export const SOCKET_DISCONNECTED_REALTIME_EVENTS = 'SOCKET_DISCONNECTED_REALTIME_EVENTS';
export const SOCKET_EVENT_REALTIME_EVENTS = 'SOCKET_EVENT_REALTIME_EVENTS';
export const REALTIME_EVENTS_SUBSCRIBE = 'REALTIME_EVENTS_SUBSCRIBE';
export const REALTIME_EVENTS_UNSUBSCRIBE = 'REALTIME_EVENTS_UNSUBSCRIBE';

export const socketConnectRealtimeEvents = (options = {}) => ({
  type: SOCKET_CONNECT_REALTIME_EVENTS,
  payload: options,
});

export const socketConnectedRealtimeEvents = () => ({
  type: SOCKET_CONNECTED_REALTIME_EVENTS,
});

export const socketDisconnectedRealtimeEvents = () => ({
  type: SOCKET_DISCONNECTED_REALTIME_EVENTS,
});

export const socketEventRealtimeEvents = event => ({
  type: SOCKET_EVENT_REALTIME_EVENTS,
  payload: { event },
});

export const realtimeEventsSubscribe = rooms => ({
  type: REALTIME_EVENTS_SUBSCRIBE,
  payload: { rooms },
});

export const realtimeEventsUnsubscribe = rooms => ({
  type: REALTIME_EVENTS_UNSUBSCRIBE,
  payload: { rooms },
});
